import React from 'react';

export const LocationAttachment = ({ latitude, longitude, name, address }: { latitude: number, longitude: number, name?: string, address?: string }) => {
    const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

    return (
        <div className="d-flex flex-column rounded overflow-hidden" style={{ minWidth: '220px', backgroundColor: 'rgba(0,0,0,0.03)' }}>
            <a href={googleMapsLink} target="_blank" rel="noopener noreferrer" className="position-relative d-block bg-light" style={{ height: '120px' }}>
                <div className="w-100 h-100 d-flex justify-content-center align-items-center text-muted">
                    <i className="ri-map-pin-2-fill fs-24 text-danger"></i>
                </div>
            </a>
            {(name || address) && (
                <div className="p-2">
                    {name && <div className="fw-semibold text-truncate" style={{ fontSize: '14px' }}>{name}</div>}
                    {address && <div className="text-muted text-truncate" style={{ fontSize: '12px' }}>{address}</div>}
                </div>
            )}
        </div>
    );
};
